/**
 * Deployment API
 */
import { deployApiClient } from './axios-instance';
import type {
  CreateDeploymentRequest,
  DeploymentDetailResponse,
  DeploymentResponse,
  DeploymentsByRunIdsRequest,
  DeploymentsByRunIdsResponse,
  UpdateDeploymentRequest,
  UpdateDeploymentResponse,
} from './types';

export const createDeployment = async (request: CreateDeploymentRequest): Promise<DeploymentResponse> => {
  const response = await deployApiClient.post<DeploymentResponse>('/api/v1/deployments', request);
  return response.data;
};

export const getDeploymentStatus = async (deploymentId: string): Promise<DeploymentDetailResponse> => {
  const response = await deployApiClient.get<DeploymentDetailResponse>(`/api/v1/deployments/${deploymentId}`);
  return response.data;
};

export const updateDeployment = async (
  deploymentId: string,
  request: UpdateDeploymentRequest
): Promise<UpdateDeploymentResponse> => {
  const response = await deployApiClient.patch<UpdateDeploymentResponse>(
    `/api/v1/deployments/${deploymentId}`,
    request
  );
  return response.data;
};

export const getDeploymentsByRunIds = async (
  request: DeploymentsByRunIdsRequest
): Promise<DeploymentsByRunIdsResponse> => {
  const response = await deployApiClient.post<DeploymentsByRunIdsResponse>(
    '/api/v1/deployments/recent/by-run-ids',
    request
  );
  return response.data;
};
